import { MUIDataTableColumn, MUIDataTableOptions } from 'mui-datatables';
import React from 'react';
import { connect } from 'react-redux';
import appConfig from 'src/appConfig';
import { Table, Text, View } from 'src/components/common';
import NewDeposition from 'src/containers/ManageDepositions/NewDeposition';
import { scheduleDepositionAction } from 'src/redux/scheduleDepositionRedux';
import { ErrorService } from 'src/services';
import { IAppState } from 'src/store';
import { getSortParam } from 'src/utils';
import Submission from '../Submission';
import { ISchedulingDepositions } from '../type';

const ScheduleDepositionList: React.VFC<Props> = ({ isLoading, onGetScheduleDepositions }) => {
  const [records, setRecords] = React.useState<ISchedulingDepositions[]>([]);
  const [total, setTotal] = React.useState<number>(0);
  const [refresh, doRefresh] = React.useState<number>(0);
  const [showSubmissionDetails, setShowSubmissionDetails] = React.useState<boolean>(false);
  const [selectedRecord, setSelectedRecord] = React.useState<any>({});
  const [isInitialDeposition, setIsInitialDeposition] = React.useState<boolean>(false);

  const handleGetSchedulingRequests = (params: any) => {
    const searchParams = {
      search: params.search ?? '',
      status: params.status ?? [],
      sort: params.sort ? getSortParam(params.sort) : 'NAME',
      order: params.order ? params.order.toUpperCase() : 'ASC',
      skip: params.skip ?? '0',
      take: params.take ?? '10',
    };
    onGetScheduleDepositions(searchParams, onGetSchedulingRequestsSuccess, ErrorService.handler);
  };
  const onGetSchedulingRequestsSuccess = (scheduleDepositionList: ISchedulingDepositions[], total: number) => {
    setRecords(scheduleDepositionList);
    setTotal(total);
  };

  const handleRowClick = (_value: any, meta: { rowIndex: number }) => {
    const index = meta.rowIndex;
    const selectedRecord: ISchedulingDepositions = records[index];
    setSelectedRecord(selectedRecord);
    handleOpenModalSubmission();
  };

  const handleOpenModalSubmission = () => {
    setShowSubmissionDetails(true);
  };

  const handleCloseModalSubmission = (needReload?: boolean) => {
    setShowSubmissionDetails(false);
    refreshTable();
  };

  const handleOpenModalInitialDeposition = () => {
    setIsInitialDeposition(true);
    setShowSubmissionDetails(false);
  };

  const handleCloseModalInitialDeposition = (needReload?: boolean) => {
    setIsInitialDeposition(false);
  };

  const refreshTable = () => {
    doRefresh(prev => prev + 1);
  };

  const tableOptions: MUIDataTableOptions = {
    rowsPerPageOptions: appConfig.ROWS_PER_PAGE_OPTIONS,
    count: total,
    onRowClick: handleRowClick,
  };

  const columns: MUIDataTableColumn[] = [
    { name: 'name', label: 'Name', options: { filter: false, sort: true } },
    { name: 'email', label: 'Email', options: { filter: false, sort: true } },
    {
      name: 'lawFirm',
      label: 'Law Firm',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value: string) => {
          return <p>{!!value ? value : '--'}</p>;
        },
      },
    },
    { name: 'phoneNumber', label: 'Phone Number', options: { filter: false, sort: true } },
    { name: 'depositionDate', label: 'Date Of Depo', options: { filter: false, sort: true } },
    { name: 'depositionTime', label: 'Time Of Depo', options: { filter: false, sort: true } },
    { name: 'depositionLocation', label: 'Depo Location', options: { filter: false, sort: true } },
  ];

  console.log(selectedRecord);

  const initialDeposition = {
    caseName: selectedRecord.caseName,
    actualDepositionDate: selectedRecord.depositionFullDate,
    depositionTime: selectedRecord.depositionFullDate,
    captions: selectedRecord.additionalNotes,
  };

  return (
    <View className="mt-32">
      {showSubmissionDetails && (
        <Submission
          onClose={handleCloseModalSubmission}
          record={selectedRecord}
          onInitialDeposition={handleOpenModalInitialDeposition}
        />
      )}
      {isInitialDeposition && (
        <NewDeposition onClose={handleCloseModalInitialDeposition} initialValue={initialDeposition} />
      )}

      <Text size={24} variant="title" className="mb-24">
        Schedule Requests
      </Text>
      <Table
        title=""
        data={records}
        tableOptions={tableOptions}
        columns={columns}
        onAction={handleGetSchedulingRequests}
        refresh={refresh}
      />
    </View>
  );
};

type Props = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps;

const mapStateToProps = (state: IAppState) => ({
  isLoading: state.common.isLoading,
});

const mapDispatchToProps = {
  onGetScheduleDepositions: scheduleDepositionAction.getScheduleDepositions,
};

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleDepositionList);
